// translations/pages/kyveil/pl.js

export const kyveilPagePL = {
  "seo": {
    "title": "Kyveil – anonimizacja PII | pAIoneer Labs GmbH",
    "description": "Kyveil wykrywa i anonimizuje dane osobowe lokalnie w Twoich systemach. Aplikacja desktopowa lub REST API do anonimizacji PII zgodnej z RODO.",
    "keywords": "Kyveil, anonimizacja PII, anonimizacja danych osobowych, ochrona danych, RODO, GDPR, Microsoft Presidio, spaCy, flair, lokalne przetwarzanie danych",
    "ogTitle": "Kyveil: profesjonalna anonimizacja PII z wykorzystaniem AI i NLP",
    "ogDescription": "Automatyczne wykrywanie i anonimizacja danych osobowych w formie aplikacji desktopowej lub REST API we własnej infrastrukturze.",
    "twitterTitle": "Kyveil – anonimizacja PII",
    "twitterDescription": "Lokalne wykrywanie i anonimizacja PII we wrażliwych dokumentach.",
    "url": "https://paioneer-labs.eu/kyveil",
    "structuredData": {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "Kyveil",
      "applicationCategory": "SecurityApplication",
      "operatingSystem": "Windows, macOS, Linux, Server",
      "description": "Oprogramowanie do lokalnego wykrywania i anonimizacji danych osobowych z wykorzystaniem AI i NLP.",
      "provider": {
        "@type": "Organization",
        "name": "pAIoneer Labs GmbH",
        "url": "https://paioneer-labs.eu"
      },
      "offers": {
        "@type": "Offer",
        "availability": "https://schema.org/InStock",
        "url": "https://paioneer-labs.eu/kyveil"
      }
    }
  },
  "hero": {
    "eyebrow": "Ochrona danych i anonimizacja",
    "title": "Kyveil",
    "subtitle": "Lokalna anonimizacja przed AI, testami i udostępnianiem.",
    "description": "Kyveil to lokalna warstwa anonimizacji dla dokumentów i przepływów pracy z AI. Oprogramowanie wykrywa dane osobowe w plikach Word, Excel, PDF oraz tekstowych, zastępuje je lub maskuje i pokazuje podgląd, zanim treść trafi do czatów AI, testów, analiz lub podmiotów zewnętrznych. Kyveil jest tworzony i stale rozwijany w podejściu [sterowanym przez IDD](idd) (Intent-Driven Development) oraz automatycznie z użyciem [Veridion](veridion) przez naszych pracowników AI z udziałem człowieka w pętli.",
    "platforms": "Aplikacja desktopowa, REST API i AnonChat",
    "proofPoints": [
      "Dokumenty pozostają lokalnie w Twoich systemach.",
      "Dane osobowe są zastępowane lub maskowane.",
      "Podgląd pokazuje zanonimizowaną treść przed udostępnieniem lub czatem AI.",
      "Word, Excel, PDF i tekst to główne przepływy pracy z dokumentami."
    ]
  },
  "dataSovereignty": {
    "title": "Twoje dane. Twoje systemy. Twoja kontrola.",
    "subtitle": "Pełna suwerenność danych dzięki lokalnemu przetwarzaniu.",
    "items": [
      {
        "title": "Chmura nie jest potrzebna",
        "description": "Całe przetwarzanie odbywa się lokalnie w Twojej infrastrukturze. Twoje pliki nigdy nie opuszczają Twoich systemów. Żadnych zależności od chmury, żadnego przesyłania danych na zewnątrz."
      },
      {
        "title": "Edge computing",
        "description": "Aplikacja desktopowa działa w pełni samodzielnie na stacjach roboczych. API jest uruchamiane na Twoich własnych serwerach. Obie wersje przetwarzają wszystko lokalnie, w obrębie Twojej strefy bezpieczeństwa."
      },
      {
        "title": "Autonomia danych",
        "description": "Pełna kontrola nad przepływami danych. Bez uzależnienia od jednego dostawcy. Bez stałych kosztów chmury. Twoje wrażliwe informacje pozostają wyłącznie pod Twoją kontrolą."
      },
      {
        "title": "Standardowy sprzęt",
        "description": "GPU nie jest wymagane. Działa na zwykłych komputerach biurowych i standardowych serwerach. Nie trzeba inwestować w specjalistyczny sprzęt."
      }
    ]
  },
  "features": {
    "title": "Najważniejsze funkcje",
    "subtitle": "Wszystko, czego potrzeba do kontrolowanego wykrywania i anonimizacji PII w procesach biznesowych.",
    "items": [
      {
        "title": "Wykrywanie PII oparte na AI",
        "description": "Automatyczne rozpoznawanie z użyciem Microsoft Presidio SDK, spaCy firmy Explosion AI oraz flair z Uniwersytetu Humboldtów w Berlinie.",
        "tone": "primary"
      },
      {
        "title": "Tryb Replace",
        "description": "Zastępuje wykryte PII ogólnymi symbolami zastępczymi, takimi jak [NAME], [EMAIL] i [ADDRESS], w scenariuszach związanych ze zgodnością z przepisami.",
        "tone": "info"
      },
      {
        "title": "Tryb Fake",
        "description": "Zastępuje wykryte PII wiarygodnymi wartościami zastępczymi na potrzeby środowisk testowych i prac programistycznych.",
        "tone": "warning"
      },
      {
        "title": "Wiele formatów dokumentów",
        "description": "Przetwarza pliki Microsoft Word, Excel, OpenDocument i PDF oraz zwykły tekst.",
        "tone": "success"
      },
      {
        "title": "Obsługa wielu języków",
        "description": "Wbudowana obsługa języków niemieckiego, angielskiego, francuskiego, włoskiego i hiszpańskiego z modelami NLP dla poszczególnych języków.",
        "tone": "secondary"
      },
      {
        "title": "Konfigurowalne wykrywanie",
        "description": "Określ, które encje PII mają być wykrywane: imiona i nazwiska, adresy, adresy e-mail, numery telefonów, rachunki bankowe, numery identyfikacji podatkowej i inne.",
        "tone": "primary"
      },
      {
        "title": "Rozszerzalność",
        "description": "Interfejsy dla własnej logiki przetwarzania wstępnego i końcowego, pozwalające na integrację z Twoimi przepływami pracy.",
        "tone": "info"
      },
      {
        "title": "Optymalizacja pod CPU",
        "description": "Wydajna architektura modeli działa na standardowym sprzęcie biurowym i nie wymaga GPU.",
        "tone": "warning"
      }
    ]
  },
  "technology": {
    "title": "Stos technologiczny",
    "subtitle": "Frameworki klasy enterprise i sprawdzone wyniki badań nad NLP.",
    "items": [
      {
        "title": "Microsoft Presidio SDK",
        "description": "Microsoft Data Protection and De-identification SDK. Standardowy w branży framework do rozpoznawania i anonimizacji PII z wbudowanymi modułami rozpoznawania encji.",
        "tone": "primary"
      },
      {
        "title": "spaCy",
        "subtitle": "Opracowane przez Explosion AI",
        "description": "Przetwarzanie języka naturalnego na skalę przemysłową. Gotowa do zastosowań produkcyjnych biblioteka NLP z wytrenowanymi modelami statystycznymi do rozpoznawania nazwanych encji.",
        "tone": "info"
      },
      {
        "title": "flair",
        "subtitle": "Opracowane przez Uniwersytet Humboldtów w Berlinie",
        "description": "Nowoczesny framework NLP z kontekstowymi osadzeniami ciągów znaków (contextual string embeddings). Zaawansowane modele sieci neuronowych zwiększające dokładność wykrywania encji.",
        "tone": "secondary"
      }
    ],
    "integration": "Zintegrowany potok AI",
    "integrationDesc": "Połączone rozpoznawanie, w którym Presidio pełni rolę warstwy orkiestracji, a modele spaCy i flair zapewniają optymalne wykrywanie w wielu językach i dla wielu typów encji."
  },
  "technicalDetails": {
    "title": "Możliwości techniczne",
    "subtitle": "Konfigurowalne wykrywanie dla europejskich dokumentów biznesowych.",
    "items": [
      {
        "title": "Obsługa języków",
        "description": "Wytrenowane modele NLP dla języków niemieckiego, angielskiego, francuskiego, włoskiego i hiszpańskiego. Rozpoznawanie encji uwzględniające specyfikę języka zapewnia dokładne wykrywanie PII w europejskich kontekstach biznesowych.",
        "tone": "primary"
      },
      {
        "title": "Konfigurowalne encje PII",
        "description": "Wybierz, jakie rodzaje danych osobowych mają być wykrywane i anonimizowane: imiona i nazwiska, adresy e-mail, numery telefonów, adresy pocztowe, rachunki bankowe IBAN, numery kart kredytowych, numery ubezpieczenia społecznego, numery identyfikacji podatkowej, numery paszportów i inne.",
        "tone": "info"
      },
      {
        "title": "Tryby anonimizacji",
        "description": "Tryb Replace zastępuje PII ogólnymi symbolami zastępczymi na potrzeby dokumentacji zgodności. Tryb Fake używa wiarygodnych wartości zastępczych w środowiskach testowych, zachowując strukturę dokumentu.",
        "tone": "warning"
      },
      {
        "title": "Przetwarzanie wstępne i końcowe",
        "description": "Zaimplementuj własną logikę przed anonimizacją i po niej. Udostępnione interfejsy pozwalają dodać walidację dokumentów, konwersję formatów, kontrole jakości, logowanie audytowe lub integrację z kolejnymi systemami.",
        "tone": "secondary"
      }
    ]
  },
  "anonChat": {
    "title": "AnonChat rozszerza Kyveil o internetowy czat AI",
    "subtitle": "Nowa aplikacja stosuje to samo podejście do anonimizacji przed właściwym czatem z zewnętrznymi lub wewnętrznymi systemami AI.",
    "eyebrow": "Nowa aplikacja",
    "name": "AnonChat",
    "description": "AnonChat to internetowy czat AI, w którym dokumenty Word i Excel można zanonimizować przed użyciem ich z ChatGPT, Claude, Gemini lub wewnętrznymi modelami LLM. Podgląd pokazuje zanonimizowany tekst, zanim treści trafią do czatu.",
    "statement": "Decyzja pozostaje w rękach użytkownika: sprawdzić, zatwierdzić, a dopiero potem rozmawiać.",
    "steps": [
      {
        "title": "Wczytaj dokument",
        "description": "Pliki Word lub Excel są przygotowywane do anonimizacji, zanim trafią do przepływu pracy z AI.",
        "tone": "primary"
      },
      {
        "title": "Zanonimizuj PII",
        "description": "Kyveil wykrywa dane osobowe i zastępuje je lub maskuje zgodnie z wybranymi regułami.",
        "tone": "info"
      },
      {
        "title": "Sprawdź podgląd",
        "description": "Zanonimizowany tekst jest widoczny, zanim treści zostaną przekazane do czatu.",
        "tone": "warning"
      },
      {
        "title": "Skorzystaj z czatu AI",
        "description": "Dopiero po sprawdzeniu zanonimizowane treści są używane z zewnętrznymi lub wewnętrznymi modelami LLM.",
        "tone": "success"
      }
    ]
  },
  "deployment": {
    "title": "Warianty wdrożenia",
    "subtitle": "Wybierz rozwiązanie odpowiednie do swojego zastosowania.",
    "options": [
      {
        "title": "Aplikacja desktopowa",
        "subtitle": "Samodzielna aplikacja dla pojedynczych stanowisk pracy",
        "description": "Wersja desktopowa działa całkowicie niezależnie w systemach Windows, macOS lub Linux. Idealna dla użytkowników, którzy muszą anonimizować dokumenty bezpośrednio na swoim stanowisku pracy, bez zależności od sieci.",
        "features": [
          "W 100% offline – połączenie z internetem nie jest wymagane",
          "Pliki nigdy nie opuszczają lokalnej stacji roboczej",
          "Przetwarzanie wsadowe wielu plików",
          "Graficzny interfejs użytkownika ułatwiający obsługę",
          "Działa na standardowych komputerach biurowych bez GPU",
          "Licencja jednorazowa – bez modelu subskrypcyjnego"
        ]
      },
      {
        "title": "REST API",
        "subtitle": "Wdrożenie serwerowe do integracji i skalowania",
        "description": "Wersja API jest wdrażana na Twoich własnych serwerach lub w infrastrukturze chmury prywatnej. Idealna do włączenia anonimizacji w istniejące systemy i przepływy pracy o dużym wolumenie przetwarzania.",
        "features": [
          "Wdrożenie we własnej infrastrukturze – on-premises lub w chmurze prywatnej",
          "Skalowanie horyzontalne przy wysokich wymaganiach dotyczących przepustowości",
          "API typu REST z obszerną dokumentacją",
          "Ten sam silnik anonimizacji co w wersji desktopowej",
          "Przykłady integracji dla popularnych platform",
          "Możliwość dostosowania przetwarzania wstępnego i końcowego"
        ]
      },
      {
        "title": "AnonChat",
        "subtitle": "Internetowy czat AI z anonimizacją przed rozmową",
        "description": "AnonChat umieszcza Kyveil przed właściwym czatem AI. Dokumenty Word i Excel są anonimizowane, podgląd jest sprawdzany i dopiero wtedy treści są używane z ChatGPT, Claude, Gemini lub wewnętrznymi modelami LLM.",
        "features": [
          "Anonimizacja przed czatem zamiast kontroli po fakcie",
          "Podgląd zanonimizowanego tekstu przed przekazaniem",
          "Zaprojektowany z myślą o pytaniach do systemów AI opartych na dokumentach",
          "Zmniejsza ryzyko wysłania danych osobowych do zewnętrznych modeli",
          "Możliwość połączenia z wewnętrznymi modelami LLM lub firmowymi rozwiązaniami czatowymi",
          "Stosuje to samo podejście do anonimizacji co aplikacja desktopowa i REST API"
        ]
      }
    ],
    "bothNote": "Aplikacja desktopowa, REST API i AnonChat zostały zaprojektowane tak, aby anonimizować wrażliwe treści przed ich dalszym przetwarzaniem."
  },
  "useCases": {
    "title": "Przypadki użycia",
    "subtitle": "Od zgodności z RODO po bezpieczne dane dla zespołów programistycznych.",
    "items": [
      {
        "title": "Zgodność z RODO",
        "description": "Anonimizuj dane osobowe przed udostępnieniem dokumentów na zewnątrz lub innym działom w organizacji. Spełnij wymogi ochrony danych dotyczące danych testowych, zbiorów danych do analiz i dokumentacji.",
        "tone": "primary"
      },
      {
        "title": "Przygotowanie danych testowych",
        "description": "Przygotuj realistyczne zbiory danych testowych, aby programiści mogli pracować na danych zbliżonych do produkcyjnych bez ujawniania prawdziwych danych osobowych.",
        "tone": "info"
      },
      {
        "title": "Przetwarzanie dokumentów kadrowych",
        "description": "Anonimizuj aplikacje kandydatów, akta pracownicze i dokumentację kadrową na potrzeby bezstronnych ocen, audytów zgodności lub analiz danych, chroniąc przy tym prywatność.",
        "tone": "warning"
      },
      {
        "title": "Analiza danych",
        "description": "Umożliw analizę dokumentów zawierających PII, anonimizując najpierw wrażliwe informacje. Udostępniaj zbiory danych między zespołami bez obaw o prywatność.",
        "tone": "success"
      },
      {
        "title": "Archiwizacja dokumentów",
        "description": "Przygotuj dokumenty do długoterminowej archiwizacji, usuwając lub anonimizując PII zgodnie z zasadami retencji i przepisami o ochronie danych.",
        "tone": "secondary"
      },
      {
        "title": "Bezpieczne udostępnianie",
        "description": "Udostępniaj dokumenty partnerom zewnętrznym, wykonawcom lub innym działom po automatycznym usunięciu wrażliwych danych osobowych.",
        "tone": "error"
      }
    ]
  },
  "releases": {
    "title": "Warianty i wsparcie",
    "subtitle": "Aktualizacje, rozszerzenia i wsparcie w zastosowaniach produkcyjnych.",
    "items": [
      {
        "title": "Desktop, API i AnonChat",
        "description": "Kyveil jest dostępny jako aplikacja desktopowa oraz jako REST API do integracji. AnonChat to czat internetowy z anonimizacją dokumentów przed rozmową.",
        "tone": "info"
      },
      {
        "title": "Wsparcie",
        "description": "Do zastosowań w firmie zapewniamy wsparcie techniczne, pomoc we wdrożeniu oraz dostosowanie oprogramowania.",
        "tone": "success"
      }
    ]
  },
  "cta": {
    "title": "Zacznij korzystać z Kyveil",
    "subtitle": "Chroń wrażliwe dokumenty, zanim trafią do AI, testów, analiz lub zostaną udostępnione.",
    "desktop": "Zapytaj o aplikację desktopową",
    "desktopSubject": "Kyveil Desktop",
    "apiContact": "Kontakt w sprawie wdrożenia REST API",
    "contact": "W sprawie demo lub oferty napisz do nas.",
    "email": "info@paioneer.eu",
    "apiSubject": "Kyveil: wdrożenie REST API",
    "contactSubject": "Kyveil: demo lub oferta"
  }
};
